// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "inner-1mUUA";
export { _1 as "__esModule", _2 as "inner" }
export default { "__esModule": _1, "inner": _2 }
